import { QRFC } from "./QRFC";

export class QAuditMetaRFC extends QRFC {
  constructor() {
    super();
  }

  InitAuditMetaRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "qauditmeta";
  }

  SetParams(orgName, user) {
    this.AddEncodedParameter("org", orgName);
    this.AddEncodedParameter("user", user);
  }

  DoTransactionComplete(response, callBackObj) {
    let parsed;
    try {
      parsed = JSON.parse(response);
    } catch (e) {
      callBackObj.AuditMetaResult(false, null);
      return;
    }
    callBackObj.AuditMetaResult(parsed.success === true, parsed);
  }
}
